import { Component, Input } from "@angular/core";
import { NgClass, NgTemplateOutlet } from "@angular/common";
import { RouterModule } from "@angular/router";

export type UiButtonSize = "s" | "m";
export type UiButtonRound = "circle" | null;
export type UiButtonVariant = "solid" | "solid-white" | "solid-accent" | 'outline-accent' | 'flat' | 'ghost';

@Component({
  selector: "ui-button",
  templateUrl: "./ui-button.component.html",
  styleUrl: "./ui-button.component.scss",
  standalone: true,
  imports: [NgClass, NgTemplateOutlet, RouterModule],
})
export class UiButtonStandalone {
  @Input() routerLink?: string | string[] | null;
  @Input() size: UiButtonSize = "m";
  @Input() round: UiButtonRound = null;
  @Input() variant: UiButtonVariant = "solid";
  @Input() class: string = "";
  @Input() disabled: boolean = false;
}
